export const SET_STEP_CREATE_MEMORY = 'SET_STEP_CREATE_MEMORY' as const;
export const SET_STEP_CREATE_MEMORY_TRIGGER = 'SET_STEP_CREATE_MEMORY_TRIGGER' as const;
export const SET_MEDIA_TYPE = 'SET_MEDIA_TYPE' as const;
export const SET_MEDIA_TYPE_TRIGGER = 'SET_MEDIA_TYPE_TRIGGER' as const;
export const SET_SHOW_MEDIA_BUTTONS = 'SET_SHOW_MEDIA_BUTTONS' as const;
export const SET_HIDE_MEDIA_BUTTONS = 'SET_HIDE_MEDIA_BUTTONS' as const;
export const SET_MEDIA_TYPE_SCREEN = 'SET_MEDIA_TYPE_SCREEN' as const;
export const CREATE_MEMORY = 'CREATE_MEMORY' as const;
export const CREATE_MEMORY_ASYNC = 'CREATE_MEMORY_ASYNC' as const;
export const GET_MEMORIES = 'GET_MEMORIES' as const;
export const GET_MEMORIES_ASYNC = 'GET_MEMORIES_ASYNC' as const;
export const RESET_OPERATION_STATE = 'RESET_OPERATION_STATE' as const;
export const DELETE_MEMORY = 'DELETE_MEMORY' as const;
export const DELETE_MEMORY_ASYNC = 'DELETE_MEMORY_ASYNC' as const;
export const UPDATE_MEMORY = 'UPDATE_MEMORY' as const;
export const UPDATE_MEMORY_ASYNC = 'UPDATE_MEMORY_ASYNC' as const;
export const SELECT_EDIT_MEMORY = 'SELECT_EDIT_MEMORY' as const;
export const PREVIEW_MEMORY = 'PREVIEW_MEMORY' as const;
export const APPROVE_MEMORY = 'APPROVE_MEMORY' as const;
export const APPROVE_MEMORY_ASYNC = 'APPROVE_MEMORY_ASYNC' as const;
export const TOGGLE_PIN_MEMORY = 'TOGGLE_PIN_MEMORY';
export const TOGGLE_PIN_MEMORY_ASYNC = 'TOGGLE_PIN_MEMORY_ASYNC';
export const RESET_APPROVE_SUCCESS = 'RESET_APPROVE_SUCCESS';
export const PAGINATE_BUBBLES = 'PAGINATE_BUBBLES' as const;
export const PAGINATE_BUBBLES_ASYNC = 'PAGINATE_BUBBLES_ASYNC' as const;

export const VIEW_MEMORY = 'VIEW_MEMORY' as const;
export const SET_MEMORY_TYPES_ASYNC = 'SET_MEMORY_TYPES_ASYNC';